module.exports = {"522631001":"德凤街道","522631002":"高屯街道","522631003":"龙形街道","522631102":"中潮镇","522631103":"孟彦镇","522631104":"敖市镇","522631105":"九潮镇","522631106":"岩洞镇","522631107":"水口镇","522631108":"洪州镇","522631109":"尚重镇","522631110":"双江镇","522631111":"肇兴镇","522631112":"龙额镇","522631113":"永从镇","522631114":"茅贡镇","522631115":"地坪镇","522631200":"顺化瑶族乡","522631201":"雷洞瑶族水族乡","522631203":"罗里乡","522631205":"坝寨乡","522631206":"口江乡","522631211":"德顺乡","522631212":"大稼乡","522631213":"平寨乡","522631214":"德化乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522631.json
// module id = 2654
// module chunks = 0